//
// TODO: this information probably should not be available to front end ?
//

import { forEach } from "lodash";
import { isAdmin } from "../utils/index";

export const canUserEditThisOrganization = ( state, instance ) => {

    //
    // get user from global data ...
    //

    let can = false;

    if( state.app && state.app.user && state.app.user.ownerUser )
    {
        let userEmail = state.app.user.identifier;
        let userId = state.app.user.ownerUser.id;
        let instanceId = instance.id;

        // console.log( '%ccanUserEditThisOrganization', 'background:green', {userId: state.app.user, instance, state });

        if( state.canUserEditThisOrganization.usersWhoCanEditInstance && state.canUserEditThisOrganization.usersWhoCanEditInstance[instanceId] )
        {
            let userList = state.canUserEditThisOrganization.usersWhoCanEditInstance[instanceId];

            // console.log( '%ccanUserEditThisOrganization', 'background:green', {userList} );

            forEach( userList, (user) => {
                if( user.id === userId )
                {
                    can = true;
                }
            });
        }

        // console.log( '%ccanUserEditThisOrganization', 'background:green', {can} );
    }

    // Atollon admin has priority
    if( state.app && state.app.role )
    {
        if( isAdmin( state.app.role ))
        {
            can = true;
        }
    }

    //
    // if( window.location.search.match('debug') )
    // {
    //     return true;
    // }

    return can;
};



// WEBPACK FOOTER //
// ./src/Atollon/CanUserEditThisOrganization.js